import { Send } from "@/components/Icons";
import { useTheme } from "@/hooks/useTheme";
import { space, fontSize, fontWeight, radius, semanticColor } from "@/styles/tokens";

interface ChatInputProps {
  value: string;
  onChange: (value: string) => void;
  onSubmit: () => void;
  disabled: boolean;
  placeholder?: string;
}

export function ChatInput({
  value,
  onChange,
  onSubmit,
  disabled,
  placeholder = "e.g. Book a standup with Sarah, 15 min",
}: ChatInputProps) {
  const { colors: c } = useTheme();

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      e.preventDefault();
      onSubmit();
    }
  };

  return (
    <div
      style={{
        padding: "10px 14px",
        borderTop: `1px solid ${c.bdr}`,
        display: "flex",
        gap: space[2],
      }}
    >
      <input
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
        aria-label="Type your scheduling message"
        style={{
          flex: 1,
          padding: "10px 14px",
          borderRadius: radius.xl,
          border: `1px solid ${c.bdr}`,
          background: c.s2,
          color: c.txt,
          fontSize: fontSize.base,
          fontFamily: "inherit",
          outline: "none",
        }}
      />
      <button
        onClick={onSubmit}
        disabled={disabled || !value.trim()}
        aria-label="Send message"
        style={{
          padding: "10px 14px",
          borderRadius: radius.xl,
          background: c.pri,
          color: semanticColor.white,
          border: "none",
          cursor: "pointer",
          fontFamily: "inherit",
          fontWeight: fontWeight.bold,
          fontSize: fontSize.base,
          opacity: disabled || !value.trim() ? 0.5 : 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Send s={14} />
      </button>
    </div>
  );
}
